import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState } from 'editor/src/store/gallery/types';

const setHideUsedPhotosReducer = (state: GalleryState, action: PayloadAction<boolean>) => {
  state.hideUsedPhotos = action.payload;
};

export default setHideUsedPhotosReducer;
